import { Badge, createDateColumn, createTextColumn, useGenericListConfig } from '@pesto/ui';

import type { UserAchRequestListItem } from './toUserAchRequestListItem';

const formatCents = (cents: number | null) => {
  if (cents === null || cents === undefined) return null;

  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
};

const statusVariant = (status: string | null) => {
  if (!status) return 'outline' as const;
  const s = status.toLowerCase();

  if (s.includes('settled') || s.includes('success')) return 'outline' as const;

  if (s.includes('return') || s.includes('fail')) return 'destructive' as const;

  return 'secondary' as const;
};

const statusColumn = {
  id: 'status',
  header: 'Status',
  cell: ({ row }: { row: { original: UserAchRequestListItem } }) =>
    row.original.status ? <Badge variant={statusVariant(row.original.status)}>{row.original.status}</Badge> : null,
};

export const useUserAchRequestsListConfig = () => {
  const columns = [
    createDateColumn<UserAchRequestListItem>('insertedAt', 'Created', (row) => row.insertedAt, {
      dateFormat: 'd MMM yyyy',
    }),
    createTextColumn<UserAchRequestListItem>('achType', 'Type', (row) => row.achType),
    createTextColumn<UserAchRequestListItem>('amount', 'Amount', (row) => formatCents(row.amountCents)),
    statusColumn,
    createDateColumn<UserAchRequestListItem>('settledAt', 'Settled', (row) => row.settledAt, {
      dateFormat: 'd MMM yyyy',
    }),
    createTextColumn<UserAchRequestListItem>('returnCode', 'Return Code', (row) => row.returnCode),
    createTextColumn<UserAchRequestListItem>('failureReason', 'Failure Reason', (row) => row.failureReason),
  ];

  return useGenericListConfig<UserAchRequestListItem>({
    columns,
    defaultSorting: [{ id: 'insertedAt', desc: true }],
  });
};
